import { render, staticRenderFns } from "./CheckAveragePositions.vue?vue&type=template&id=380f0bc7&"
import script from "./CheckAveragePositions.vue?vue&type=script&lang=js&"
export * from "./CheckAveragePositions.vue?vue&type=script&lang=js&"
import style0 from "./CheckAveragePositions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
